module.exports = __webpack_public_path__ + "img/sm.48089e01.svg";